// put all static breadcrumbs here
export const Users = "Users";
export const Sites = "Sites";
export const Groups = "Groups";
export const Workspace = "My Workspace";
